function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M30.9375 32.8125H31.3235C34.7347 32.8125 37.5 30.1192 37.5 26.7969C37.5 23.7547 35.1814 21.2399 32.1713 20.8375C31.7528 15.9926 27.5827 12.1875 22.5 12.1875C18.004 12.1875 14.222 15.1649 13.1192 19.2056C9.91109 19.8531 7.5 22.621 7.5 25.9375C7.5 29.5719 10.3956 32.5477 14.0625 32.7958",
  stroke: "#F0F0F5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M21.8901 28.3005C21.8515 28.1884 21.7557 28.1074 21.6416 28.0906L19.0906 27.5734L20.691 23.8892C20.7337 23.79 20.7252 23.675 20.6677 23.5837C20.6105 23.4926 20.5122 23.4375 20.407 23.4375H16.4727C16.3053 23.4375 16.168 23.5742 16.162 23.7466L15.9377 30.2939C15.932 30.4575 16.047 30.5992 16.2041 30.6225L17.692 30.9825L15.3844 37.9618C15.3084 38.1041 15.3471 38.282 15.4746 38.3772C15.5296 38.4181 15.593 38.4375 15.6565 38.4375C15.7407 38.4375 15.8242 38.4022 15.8852 38.3338L21.8263 28.6249C21.9042 28.5374 21.9287 28.4126 21.8901 28.3005Z",
  fill: "#FFB900"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M22.5 34.0595L24.8438 30M26.25 35.9345L28.5938 31.875",
  stroke: "#F0F0F5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgThunderstorm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunderstorm);
export default __webpack_public_path__ + "static/media/thunderstorm.63ee7763.svg";
export { ForwardRef as ReactComponent };